export const unique = <T>(arr: T[], key: keyof T): T[] => {
  const keys = new Set();
  return arr.filter((el) => !keys.has(el[key]) && keys.add(el[key]));
};
